import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, LinkButton, Text } from '@common-fe/common-fe';

import { Service } from '@/modules/UseMyMoney/UseMyMoney.types';

interface Props {
  service?: Service;
  handleChangeService: (serviceId?: string) => void;
}

const AiSuggestedServicesListItem: React.FC<Props> = ({ service, handleChangeService }) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testId="ai-suggested-services-list_item"
      direction="row"
      round="button2Round"
      justify="between"
      align="center"
      gap="spacing8"
      pad={{ horizontal: 'spacing12', vertical: 'spacing8' }}
      margin={{ top: 'spacing4' }}
      border={{ size: '1px', color: 'border1' }}
    >
      <Text data-testId="ai-suggested-services-list_item-title">
        {service?.name}
      </Text>
      <LinkButton
        testId="ai-suggested-services-list_item-select"
        onClick={() => handleChangeService(service?.id)}
        linkInlineMode
        >
        {t('Select')}
      </LinkButton>
    </Box>
  );
};

export default AiSuggestedServicesListItem;
